



























































































import {Vue, Component, Prop} from 'vue-property-decorator';
import {Title} from '@/components/Title';
import {mapActions, mapGetters} from 'vuex';
import debounce from 'lodash.debounce';

@Component({
  name: 'ProfileNotifications',
  components: {
    Title,
  },
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      page: 1,
      search: '',
      actualNotificationId: '',
      actualCount: null,
      debounced: debounce(this.searchNotification, 500),
      infiniteId: +new Date(),
    };
  },
  computed: {
    ...mapGetters('profile', ['getNotifications', 'myNotificationsTexts']),
    openedNotification() {
      return this.getNotifications.results.find(this.findNotification);
    },
    query() {
      return {
        page: this.page,
        search: this.search,
      };
    },
  },
  methods: {
    ...mapActions('profile', ['fetchNotifications', 'makeNotificationRead', 'clearNotifications', 'checkNotification']),
    formattedDate(date) {
      return this.$dayjs(date).format('DD.MM.YY');
    },
    openNotification(notification, count) {
      if (notification) {
        this.actualNotificationId = notification.id;
        this.actualCount = count;
        if (!notification.is_read) {
          this.makeNotificationRead(notification.id);
          this.checkNotification();
        }
      }
    },
    findNotification(element) {
      return element && element.id === this.actualNotificationId ? element : false;
    },
    nextNotification() {
      this.actualCount = this.actualCount + 1;
      this.openNotification(this.getNotifications.results[this.actualCount], this.actualCount);
      Vue.nextTick(this.showActiveElement);
    },
    prevNotification() {
      this.actualCount = this.actualCount - 1;
      this.openNotification(this.getNotifications.results[this.actualCount], this.actualCount);
      Vue.nextTick(this.showActiveElement);
    },
    showActiveElement() {
      const activeElement = document.querySelector('.profileNotifications-component__content-left-row.active');
      if (activeElement) {
        activeElement.scrollIntoView();
      }
    },
    infiniteHandler($state) {
      this.fetchNotifications(this.query).then((data) => {
        if (data.next_page) {
          this.page += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    searchNotification() {
      this.clearNotifications();
      this.page = 1;
      this.infiniteId += 1;
    },
  },
  watch: {
    search(value) {
      this.debounced();
    },
  },
  destroyed() {
    this.clearNotifications();
  },
})
export default class ProfileNotifications extends Vue {}
